import { createFileRoute, useNavigate, Link } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';
import { pipelineService } from '@/features/pipeline/services/pipeline.service';
import { AssetForm } from '@/features/pipeline/components/AssetForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/pipeline/assets/novo')({
  component: NovoAssetPage,
});

function NovoAssetPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();

  const mutation = useMutation({
    mutationFn: pipelineService.createAsset,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['pipeline-assets'] });
      toast.success('Asset criado!');
      navigate({ to: '/pipeline/assets' });
    },
    onError: () => toast.error('Erro ao criar asset'),
  });

  return (
    <PermissionGate permission={Permission.PIPELINE_MANAGE_ASSETS}>
      <div className="p-6 max-w-3xl mx-auto space-y-4">
        <Link
          to="/pipeline/assets"
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" /> Assets
        </Link>
        <Card>
          <CardHeader>
            <CardTitle>Novo asset</CardTitle>
          </CardHeader>
          <CardContent>
            <AssetForm
              onSubmit={mutation.mutate}
              isLoading={mutation.isPending}
              submitLabel="Criar asset"
              onCancel={() => navigate({ to: '/pipeline/assets' })}
            />
          </CardContent>
        </Card>
      </div>
    </PermissionGate>
  );
}
